<template>
  <div class="modal-card" ref="element">

    <header class="modal-card-head">
      <p class="modal-card-title">{{editEnabled ? isSpecialOffer ? "Edit special offer" : "Edit menu" : isSpecialOffer ? "Add special offer" : "Add menu"}}</p>
    </header>

    <header class="modal-card-head" style="background-color:white;border-radius:0px;">
       <b-field label="Menu Name:">
          <b-input :disabled="role === 'viewer'" type="text" v-model="name" placeholder="Menu Name"></b-input>
        </b-field>

        <b-field v-if="bMenuError" style="color: red">
          Please enter a name.
        </b-field>
    </header>
    <section class="modal-card-body" >
      <p style="margin-top:-10px">Menu Items:</p>
      <b-table :mobile-cards="false" :data="tableData.length > 0 ? tableData : []" striped
        :draggable="role !== 'viewer'"
        @dragstart="dragstart"
        @drop="drop"
        @dragover="dragover"
        @dragleave="dragleave">

        <template slot-scope="props">
          <b-table-column centered>
            <b-icon icon="grip-vertical">
            </b-icon>
          </b-table-column>
          <b-table-column field="name" label="Name" centered>
            {{props.row.name}}
          </b-table-column>
          <b-table-column label="Edit/Remove" centered>
            <b-button type="is-info" icon-left="edit" @click="editItemModal(props.index)"></b-button>
            <b-button :disabled="role === 'viewer'" type="is-danger" icon-left="trash" @click="confirmRemoveItem(props.index, props.row.name, props.row.resourceName, props.row.resourceSize, props.row.isNew, props.row)"></b-button>
          </b-table-column>
        </template>

        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>No items to display.</p>
            </div>
          </section>
        </template>
      </b-table>
     </section>
<footer class="modal-card-foot" style="background-color:white;border-radius:0px">
      <b-button :disabled="role === 'viewer'" margin-right="100px" type="is-success" icon-left="plus" @click="addItemModal">Add item</b-button>
         <p><b>No. of items: {{items.length}}</b></p>
  </footer>
    <footer class="modal-card-foot">
      <b-button :disabled="role === 'viewer'" type="is-info" @click="saveMenu" v-if="editEnabled">Submit</b-button>
      <b-button type="is-info" icon-left="plus" @click="addMenu" v-else >Add new menu</b-button>
      <b-button type="is-light" @click="closeModal()">Cancel</b-button>
    </footer>

  </div>
</template>

<script>
import MenuItemAddEdit from '@/components/menu/items/MenuItemAddEdit'

export default {
  name: 'MenuAddEdit',
  props: ['editEnabled', 'propId', 'propParentFn', 'isSpecialOffer'],
  data: () => {
    return {
      name: '',
      tableData: [],
      items: [],
      existingFileList: [],
      filesToRemove: [],
      menuId: '',
      draggingRow: null,
      draggingRowIndex: null,
      bMenuError: false,
      loadingComponent: null,
      filesToArchive: [],
      archiveItems: [],
      deleteFromBinItems: [],
      finishedArchive: false,
      finishedUpload: false,
      totalStorageSize: null,
      sizesPlus: 0,
      sizesMinus: 0,
      namesMinus: [],
      jsonResp: null,
      editedItemsLogs: [],
      oldMSName: null,
      addedItemsLogs: [],
      addedItemsEditLogs: [],
      deletedItemsLogs: []
      // filesToKeep: []
    }
  },
  computed: {
    playlists () {
      return this.$store.state.playlists
    },
    menus () {
      return this.$store.state.menus
    },
    specialOffers () {
      return this.$store.state.specialOffers
    },
    playlistsArchive () {
      return this.$store.state.playlistsArchive
    },
    menusArchive () {
      return this.$store.state.menusArchive
    },
    specialOffersArchive () {
      return this.$store.state.specialOffersArchive
    },
    workspaceId () {
      return this.$store.state.workspaceId
    },
    role () {
      return this.$store.state.role
    },
    userId () {
      return this.$store.state.uid
    }
  },
  created: function () {
    fetch('https://api.seeip.org/geoip').then(
      (response) => response.json()
    ).then(
      (jsonResponse) => {
        this.jsonResp = jsonResponse
        this.globalLogger(this.jsonResp)
      }
    )
  },
  mounted: function () {
    if (this.editEnabled) {
      let id = this.propId
      if (this.isSpecialOffer) {
        this.editStaticMenuRef = Object.assign({}, this.$store.getters.getSpecialOffer(id))
      } else {
        this.editStaticMenuRef = Object.assign({}, this.$store.getters.getMenu(id))
      }
      this.name = this.editStaticMenuRef.name
      this.oldMSName = this.editStaticMenuRef.name
      this.menuId = id
      if (this.editStaticMenuRef.items) {
        this.items = [...this.editStaticMenuRef.items.filter(x => x)]
        for (let i = 0; i < this.items.length; i++) {
          this.items[i].isNew = false
        }
      }
      this.globalLogger(this.items[0], 'MOUNTED')
      let menuFilesRef = null
      if (this.isSpecialOffer) {
        if (!this.getNotMigrated().includes(this.userId)) {
          menuFilesRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/SpecialOffers/' + id)
        } else {
          menuFilesRef = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/SpecialOffers/' + id)
        }
      } else {
        if (!this.getNotMigrated().includes(this.userId)) {
          menuFilesRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/Menus/' + id)
        } else {
          menuFilesRef = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/Menus/' + id)
        }
      }
      menuFilesRef.listAll().then((dir) => {
        dir.items.forEach(fileRef => {
          this.existingFileList.push(fileRef.name)
        })
        this.globalLogger('EXISTING: ', this.existingFileList)
      })
      if (this.isSpecialOffer) {
        if (this.$store.state.specialOffersArchive !== null) {
          this.archiveItems = this.$store.state.specialOffersArchive.items
          this.globalLogger('SO archive: ', this.archiveItems)
        }
      } else {
        if (this.$store.state.menusArchive !== null) {
          this.archiveItems = this.$store.state.menusArchive.items
          this.globalLogger('menus archive: ', this.archiveItems)
        }
      }
    }
    this.refreshItemsTable()
  },
  methods: {
    refreshItemsTable () {
      this.tableData = []
      for (let item in this.items) {
        this.tableData.push({ id: item, ...this.items[item] })
      }
    },
    addItemModal () {
      if (this.role !== 'viewer') {
        this.$buefy.modal.open({
          parent: this,
          component: MenuItemAddEdit,
          props: { propParentFn: this.receiveItemFromChild, isSpecialOffer: this.isSpecialOffer },
          hasModalCard: true,
          trapFocus: true,
          canCancel: ['x']
        })
      }
    },
    receiveItemFromChild (item, delBinItem, sizeOfRes, nameOfRes, sMinus) {
      this.globalLogger('receive item from child', 'empty')
      item.isNew = true
      item.resourceName = nameOfRes

      if (sizeOfRes !== undefined && sizeOfRes !== null && nameOfRes !== undefined && nameOfRes !== null) {
        let znameZ = true
        this.globalLogger('this.items', this.items)
        for (let z = 0; z < this.items.length; z++) {
          this.globalLogger(this.items[z].resourceName, nameOfRes)
          this.globalLogger(this.items[z].resourceSize, sizeOfRes)
          if (this.items[z].resourceName === nameOfRes && this.items[z].resourceSize === sizeOfRes) { // dali istiot resurs vekje se koristi od drug item
            znameZ = false
            this.globalLogger('uslov za', 'zname false')
          } else if (this.items[z].resourceName === nameOfRes) { // dali resurs so isto ime vekje se koristi
            let znameM = true
            for (let u = 0; u < this.namesMinus.length; u++) {
              if (this.namesMinus[u] === this.items[z].resourceName) {
                znameM = false
                this.globalLogger('znameM ', 'e false')
              }
            }
            if (znameM) {
              this.globalLogger('znameM', ' e true')
              this.namesMinus.push(this.items[z].resourceName)
              this.sizesMinus += this.items[z].resourceSize
            }
            this.globalLogger('sizes Minus', 'vo uslov')
          }
        }
        if (znameZ) {
          this.globalLogger('zname', 'e true')
          this.sizesPlus += sizeOfRes
        }
        this.globalLogger('sizesPlus: ', this.sizesPlus)
      }
      /* for (let k = 0; k < this.items.length; k++) {
        this.globalLogger('here')
        this.globalLogger(this.items[k])
        this.globalLogger(this.items[k].resourceName, nameOfRes, this.items[k].resourceSize, sizeOfRes)
        if (this.items[k].resourceName === nameOfRes && this.items[k].resourceSize !== sizeOfRes) {
          this.globalLogger('USLOV!')
          this.items[k].resourceSize = item.resourceSize
        }
      } */

      this.items.push(item)

      if (delBinItem !== undefined && delBinItem !== null) {
        if (this.deleteFromBinItems === null) {
          this.deleteFromBinItems = []
        }
        var flag = 1
        for (let i = 0; i < this.deleteFromBinItems.length; i++) {
          if (this.deleteFromBinItems[i] === delBinItem) {
            flag = 0
          }
        }
        if (flag === 1) {
          this.deleteFromBinItems.push(delBinItem)
        }
        this.globalLogger('delete from bin itemS in receive: ', this.deleteFromBinItems)
      }
      // sizeOfRes bese tuka
      // proverka dali ima dr item so resurs so isto ime, bidejki ke se prezapise, pa ako i size kaj noviot resurs e razlicno,
      // treba da se updatira resourceSize kaj stariot item
      for (let itemId in this.items) {
        this.globalLogger(this.items[itemId], 'item[itemid')
        this.globalLogger(this.items[itemId].resourceName, nameOfRes)
        this.globalLogger(this.items[itemId].resourceSize, sizeOfRes)
        if (this.items[itemId].resourceName === nameOfRes && this.items[itemId].resourceSize !== sizeOfRes) {
          this.globalLogger('USLOV', 'empty')
          this.items[itemId].resourceSize = sizeOfRes
        }
      }
      // kraj na proverka

      // ako e uploadirano od bin
      if (sMinus !== null) {
        this.globalLogger('sMinus', 'ne e null')
        this.sizesMinus += sMinus
      }
      this.refreshItemsTable()
    },
    confirmRemoveItem (id, itemName, fileN, fileSize, isNew, remItem) {
      if (this.role !== 'viewer') {
        this.globalLogger(id, fileN)
        this.globalLogger(itemName, fileSize)
        this.$buefy.dialog.confirm({
          message: 'Do you want to <b>delete</b> item "' + itemName + '"?',
          confirmText: 'Delete',
          type: 'is-danger',
          onConfirm: () => {
            if (this.editEnabled) {
            // var log = { ip_addr: this.jsonResp.ip, city: this.jsonResp.city, playlistId: this.propId, type: item.type, userId: item.userId }
              var logItemDel = Object.assign({}, remItem)
              logItemDel.ip_addr = this.jsonResp ? this.jsonResp.ip : ''
              logItemDel.city = this.jsonResp ? this.jsonResp.city : ''
              this.deletedItemsLogs.push(logItemDel)
            }
            var isUsed = false
            var brojac = 0
            this.items = this.items.filter((x) => { return this.items.indexOf(x) !== parseInt(id) })
            if (fileN !== '' && fileN !== undefined) {
              for (let i = 0; i < this.items.length; i++) {
                if (this.items[i].resourceName === fileN) {
                  this.globalLogger('is used is true', fileN)
                  brojac++
                  isUsed = true
                }
              }
            }
            if (isUsed && !isNew) {
              var mess = null
              if (brojac > 1) {
                mess = 'The resource "' + fileN + '" is also used by other items and will remain in the menu.'
                // this.$buefy.dialog.alert('The resource "' + fileN + '" is being used by other items and will remain in the playlist.')
              } else {
                mess = 'The resource "' + fileN + '" is also used by another item and will remain in the menu.'
              }
              this.$buefy.toast.open({
                duration: 8000,
                message: mess
              })
              this.refreshItemsTable()
            } else if (isNew || fileN === '') {
              this.globalLogger('new', 'e')
              this.items = this.items.filter((x) => { return this.items.indexOf(x) !== parseInt(id) })
              var fff = true
              for (let d = 0; d < this.items.length; d++) {
                if (this.items[d].resourceName === fileN && this.items[d].resourceSize === fileSize) { // dali go ima drug item toj resurs
                  fff = false
                }
              }
              if (fff) {
                this.globalLogger('fff', 'e true')
                this.sizesMinus += fileSize
                this.globalLogger('sizes Minus', this.sizesMinus)
              }
              // this.items = this.items.filter((x) => { return this.items.indexOf(x) !== parseInt(id) })
              this.refreshItemsTable()
            } else {
              this.$buefy.dialog.confirm({
                message: 'Do you also want to delete the resource associated with this item ("' + fileN + '")?',
                cancelText: 'Archive resource',
                confirmText: 'Delete forever',
                type: 'is-danger',
                onConfirm: () => {
                  let ff = true
                  for (let t = 0; t < this.items.length; t++) {
                    if (this.items[t].resourceName === fileN && this.items[t].resourceSize === fileSize) { // dali go ima drug item toj resurs
                      ff = false
                    }
                  }
                  if (ff) {
                    this.globalLogger('ff e', 'true')
                    this.sizesMinus += fileSize
                  }
                  this.globalLogger('sizesMinus vo delete item', this.sizesMinus)
                  this.$buefy.toast.open({
                    duration: 3000,
                    message: 'The changes will take effect on submit'
                  })
                },
                onCancel: () => {
                  this.globalLogger('on', 'Cancel')
                  this.filesToArchive.push({ 'resName': fileN, 'resSize': fileSize })
                  // this.filesToKeep.push(fileN)
                  this.$buefy.toast.open({
                    duration: 3000,
                    message: 'The changes will take effect on submit'
                  })
                }
              })
              // this.items = this.items.filter((x) => { return this.items.indexOf(x) !== parseInt(id) })
              this.refreshItemsTable()
            }
          }
        })
      }
    },
    editItemModal (id) {
      this.$buefy.modal.open({
        parent: this,
        component: MenuItemAddEdit,
        props: { propItem: this.items[id], propId: id, propParentFn: this.updateItemFromChild, isSpecialOffer: this.isSpecialOffer, menId: this.propId },
        hasModalCard: true,
        trapFocus: true,
        canCancel: ['x']
      })
    },
    updateItemFromChild (item, oldItem, id, toRemove, toArchive, delBinItem, sizeOfRes, nameOfRes, sizeOfResOld, nameOfResOld) {
      this.globalLogger('toRemove: ', toRemove)
      this.globalLogger('toArchive: ', toArchive)
      this.globalLogger('update item from child: ', item.isNew)

      if (this.editEnabled) {
        var log = { ip_addr: this.jsonResp ? this.jsonResp.ip : '', city: this.jsonResp ? this.jsonResp.city : '', userId: item.userId }
        if (this.isSpecialOffer) {
          log.offerId = this.propId
        } else {
          log.menuId = this.propId
        }
        if (item.name !== oldItem.name) {
          log.oldName = oldItem.name
          log.newName = item.name
        } else {
          log.name = item.name
        }
        if (item.description !== oldItem.description) {
          log.oldDescription = oldItem.description
          log.newDescription = item.description
        }
        if (this.isSpecialOffer) {
          if (item.price !== oldItem.price) {
            log.oldPrice = oldItem.price
            log.newPrice = item.price
          }
        }
        if (item.file) {
          // ako se menuva postoecka slika
          if (oldItem.resourceName && oldItem.resourceSize && item.file.name !== oldItem.resourceName && item.file.size !== oldItem.resourceSize) {
            this.globalLogger('se menuva postoecka slika')
            log.oldResourceName = oldItem.resourceName
            log.oldResourceSize = oldItem.resourceSize
            log.newResourceName = item.file.name
            log.newResourceSize = item.file.size
          } else if (!oldItem.resourceName) {
            this.globalLogger('se dodava slika (prethodno nemalo)')
            log.newResourceName = item.file.name
            log.newResourceSize = item.file.size
          }
        }
        this.editedItemsLogs.push(log)
        this.globalLogger('log: ', log)
      }

      this.items[id] = item
      if (toRemove !== undefined) {
        if (toRemove.length > 0) {
          for (let i = 0; i < toRemove.length; i++) {
            this.filesToRemove.push(toRemove[i])
            this.globalLogger(toRemove[i], 'empty')
          }
        }
      }
      if (toArchive !== undefined) {
        if (toArchive.length > 0) {
          for (let i = 0; i < toArchive.length; i++) {
            this.filesToArchive.push(toArchive[i])
            this.filesToRemove.push(toArchive[i].resName)
            this.globalLogger('toArchive[i]: ', toArchive[i])
          }
        }
      }
      this.globalLogger('update ', 'del')
      this.globalLogger(sizeOfRes, 'sizeOfRes')
      if (sizeOfRes !== undefined && sizeOfRes !== null && nameOfRes !== undefined && nameOfRes !== null) {
        let znameZZ = true
        this.globalLogger('this.items', this.items)
        for (let z = 0; z < this.items.length; z++) {
          // this.globalLogger(this.items[z].resourceName, nameOfRes, this.items[z].resourceSize, sizeOfRes)
          if (this.items[z].resourceName === nameOfRes && this.items[z].resourceSize === sizeOfRes) { // dali istiot resurs vekje se koristi od drug item
            znameZZ = false
            this.globalLogger('uslov za zname', 'false')
          } else if (this.items[z].resourceName === nameOfRes) { // dali resurs so isto ime vekje se koristi
            let znameM = true
            for (let u = 0; u < this.namesMinus.length; u++) {
              if (this.namesMinus[u] === this.items[z].resourceName) {
                znameM = false
                this.globalLogger('znameM e ', 'false')
              }
            }
            if (znameM) {
              this.globalLogger('znameM e ', 'true')
              this.namesMinus.push(this.items[z].resourceName)
              this.sizesMinus += this.items[z].resourceSize
            }
            this.globalLogger('sizes Minus', 'vo uslov')
          }
        }
        if (znameZZ) {
          this.globalLogger('zname e ', 'true')
          this.sizesPlus += sizeOfRes
        }
        this.globalLogger('sizesPlus: ', this.sizesPlus)
      }

      if (sizeOfResOld !== undefined && sizeOfResOld !== null && nameOfResOld !== undefined && nameOfResOld !== null) {
        let znameN = true
        for (let m = 0; m < this.items.length; m++) {
          if (this.items[m].resourceName === nameOfResOld && this.items[m].resourceSize === sizeOfResOld) { // dali istiot resurs vekje se koristi od drug item
            znameN = false
          }
        }
        if (znameN) {
          let znameNN = true
          for (let o = 0; o < this.namesMinus.length; o++) {
            if (this.namesMinus[o] === nameOfResOld) {
              znameNN = false
              this.globalLogger('znameNN', 'e false')
            }
          }
          if (znameNN) {
            this.globalLogger('znameNN', 'e true')
            this.sizesMinus += sizeOfResOld
            this.globalLogger('sizesMin', this.sizesMinus)
          }
        }
      }

      if (delBinItem !== undefined && delBinItem !== null) {
        if (this.deleteFromBinItems === null) {
          this.deleteFromBinItems = []
        }
        var flag = 1
        for (let i = 0; i < this.deleteFromBinItems.length; i++) {
          if (this.deleteFromBinItems[i] === delBinItem) {
            flag = 0
          }
        }
        if (flag === 1) {
          this.deleteFromBinItems.push(delBinItem)
        }
        this.globalLogger('delete from bin itemS: ', this.deleteFromBinItems)
      }
      this.refreshItemsTable()
    },
    addMenu () {
      if (this.role !== 'viewer') {
        if (this.name === '') {
          this.bMenuError = true
        } else if (this.storageAvailable()) {
          this.loadingComponent = this.$buefy.loading.open({
            container: this.$refs.element.$el
          })
          let newMenuRef = null
          if (this.isSpecialOffer) {
            if (!this.getNotMigrated().includes(this.userId)) {
              newMenuRef = this.$store.state.database.ref('/neoslide/specialOfferMenu/' + this.workspaceId).push()
            } else {
              newMenuRef = this.$store.state.database.ref('/specialOfferMenu/' + this.userId).push()
            }
          } else {
            if (!this.getNotMigrated().includes(this.userId)) {
              newMenuRef = this.$store.state.database.ref('/neoslide/menu/' + this.workspaceId).push()
            } else {
              newMenuRef = this.$store.state.database.ref('/menu/' + this.userId).push()
            }
          }
          this.menuId = newMenuRef['key']
          this.globalLogger('menuId', this.menuId)
          // za logiranje
          if (this.isSpecialOffer) {
            this.$analytics.logEvent('add_offer', {
              name: this.name,
              ip_addr: this.jsonResp ? this.jsonResp.ip : '',
              city: this.jsonResp ? this.jsonResp.city : ''
            })
          } else {
            this.$analytics.logEvent('add_menu', {
              name: this.name,
              ip_addr: this.jsonResp ? this.jsonResp.ip : '',
              city: this.jsonResp ? this.jsonResp.city : ''
            })
          }
          // -- za logiranje
          newMenuRef.set({
            name: this.name,
            // items: this.items,
            userId: this.$store.state.uid
          }).then(() => {
            // this.submitFiles()
            this.removeUnusedFiles(true)
            // this.closeModal()
          })
        } else {
          this.$buefy.dialog.confirm({
            title: 'Storage full',
            message: 'The upload cannot be done because you have used up your available storage.',
            hasIcon: true,
            confirmText: 'OK',
            type: 'is-danger'
          })
        }
      }
    },
    saveMenu () {
      if (this.role !== 'viewer') {
        if (this.name === '') {
          this.bMenuError = true
        } else if (this.storageAvailable()) {
          this.loadingComponent = this.$buefy.loading.open({
            container: this.$refs.element.$el
          })
          let id = this.menuId
          let editMenuRef = null
          if (this.isSpecialOffer) {
            if (!this.getNotMigrated().includes(this.userId)) {
              editMenuRef = this.$store.state.database.ref('/neoslide/specialOfferMenu/' + this.workspaceId + '/' + id)
            } else {
              editMenuRef = this.$store.state.database.ref('/specialOfferMenu/' + this.userId + '/' + id)
            }
          } else {
            if (!this.getNotMigrated().includes(this.userId)) {
              editMenuRef = this.$store.state.database.ref('/neoslide/menu/' + this.workspaceId + '/' + id)
            } else {
              editMenuRef = this.$store.state.database.ref('/menu/' + this.userId + '/' + id)
            }
          }
          for (let itemId in this.items) {
            this.items[itemId].id = itemId
          }
          // za logiranje
          var menObject = {
            name: this.name,
            ip_addr: this.jsonResp ? this.jsonResp.ip : '',
            city: this.jsonResp ? this.jsonResp.city : ''
          }
          if (this.name !== this.oldMSName) {
            menObject.oldName = this.oldMSName
          }
          if (this.isSpecialOffer) {
            this.$analytics.logEvent('edit_offer', menObject)
          } else {
            this.$analytics.logEvent('edit_menu', menObject)
          }
          // -- za logiranje
          editMenuRef.update({
            name: this.name
            // items: this.items
          }, () => {
            this.removeUnusedFiles(false)
            // this.closeModal()
          })
        } else {
          this.$buefy.dialog.confirm({
            title: 'Storage full',
            message: 'The upload cannot be done because you have used up your available storage.',
            hasIcon: true,
            confirmText: 'OK',
            type: 'is-danger'
          })
        }
      }
    },
    removeUnusedFiles (isAdd) {
      this.globalLogger('remove unused ', 'files')
      for (let fileName of this.existingFileList) {
        let isReferenced = false
        for (let item of this.items) {
          this.globalLogger(item.resourceName, fileName)
          if (item.resourceName === fileName) {
            isReferenced = true
            break
          }
        }
        if (!isReferenced) {
          this.filesToRemove.push(fileName)
        }
      }

      /* for (let fRemove of this.filesToRemove) {
        for (let fKeep of this.filesToKeep) {
          if (fRemove === fKeep) {
            this.globalLogger('File should be kept: ', fKeep)
            this.filesToRemove = this.filesToRemove.filter((x) => { return x !== fKeep })
            this.globalLogger('filesTOREMOVE: ', this.filesToRemove)
          }
        }
      } */
      this.globalLogger('files to remove: ', this.filesToRemove)
      this.filesToRemove = [...new Set(this.filesToRemove)]
      if (this.filesToRemove.length === 0) {
        this.globalLogger('Nothing to', 'remove')
      }

      this.globalLogger('items: ', this.deleteFromBinItems)
      if (this.deleteFromBinItems.length > 0) {
        let deleteBinPromiseList = []
        this.globalLogger('brisenje', 'od bin')
        let removeMenuFilesRef = null
        if (this.isSpecialOffer) {
          if (!this.getNotMigrated().includes(this.userId)) {
            removeMenuFilesRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/SpecialOffersArchive/')
          } else {
            removeMenuFilesRef = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/SpecialOffersArchive/')
          }
        } else {
          if (!this.getNotMigrated().includes(this.userId)) {
            removeMenuFilesRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/MenusArchive/')
          } else {
            removeMenuFilesRef = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/MenusArchive/')
          }
        }
        removeMenuFilesRef.listAll().then(dir => {
          dir.items.forEach(fileRef => {
            if (this.deleteFromBinItems.includes(fileRef.name)) {
              this.globalLogger('removing file ', fileRef.name)
              deleteBinPromiseList.push(fileRef.delete())
            }
          })
        }).finally(() => {
          Promise.all(deleteBinPromiseList).then(() => {
            let itemsDel = null
            if (this.isSpecialOffer) {
              itemsDel = this.$store.state.specialOffersArchive.items
            } else {
              itemsDel = this.$store.state.menusArchive.items
            }
            if (itemsDel !== null) {
              this.globalLogger('files to Delete: ', this.deleteFromBinItems)
              var binItems = []
              if (this.isSpecialOffer) {
                binItems = this.$store.state.specialOffersArchive.items
              } else {
                binItems = this.$store.state.menusArchive.items
              }
              this.globalLogger('binItems before: ', binItems)
              for (let i = 0; i < this.deleteFromBinItems.length; i++) {
                binItems = binItems.filter(c => c.resName !== this.deleteFromBinItems[i])
              }
              this.globalLogger('binItems after: ', binItems)
              if (this.isSpecialOffer) {
                if (!this.getNotMigrated().includes(this.userId)) {
                  this.$store.state.database.ref('/neoslide/archive/' + this.workspaceId + '/specialOffers/').update({
                    items: binItems
                  })
                } else {
                  this.$store.state.database.ref('/archive/' + this.userId + '/specialOffers/').update({
                    items: binItems
                  })
                }
              } else {
                if (!this.getNotMigrated().includes(this.userId)) {
                  this.$store.state.database.ref('/neoslide/archive/' + this.workspaceId + '/menus/').update({
                    items: binItems
                  })
                } else {
                  this.$store.state.database.ref('/archive/' + this.userId + '/menus/').update({
                    items: binItems
                  })
                }
              }
            }
            // this.$parent.close()
            // this.loadingComponent.close()
          })
        })
      }

      if (this.filesToArchive.length !== 0) {
        var count1 = 0
        var count2 = 0
        var archiveItemsCopy = []
        for (let z = 0; z < this.archiveItems.length; z++) {
          archiveItemsCopy[z] = this.archiveItems[z]
        }
        // var archiveItemsCopy = this.archiveItems
        for (let x = 0; x < this.filesToArchive.length; x++) {
          var znak = 1
          for (let y = 0; y < archiveItemsCopy.length; y++) {
            if (archiveItemsCopy[y].resName === this.filesToArchive[x].resName && archiveItemsCopy[y].resSize === this.filesToArchive[x].resSize) {
              this.globalLogger('znak', 'e 0')
              znak = 0
            } else if (archiveItemsCopy[y].resName === this.filesToArchive[x].resName) {
              this.globalLogger('samo', 'imeto')
              archiveItemsCopy = archiveItemsCopy.filter(x => x.resName !== this.filesToArchive[x].resName)
            }
          }
          if (znak === 1) {
            count1++
            archiveItemsCopy.push(this.filesToArchive[x])
          }
          this.globalLogger('files to archive ', this.filesToArchive[x])
        }
        this.globalLogger('arch items copy length: ', archiveItemsCopy.length)
        this.globalLogger('this.archiveItems length', this.archiveItems.length)

        var flag = 0
        for (let i = 0; i < this.filesToArchive.length; i++) {
          this.globalLogger('file to archive', this.filesToArchive[i])
          let fileRef = null
          if (this.isSpecialOffer) {
            if (!this.getNotMigrated().includes(this.userId)) {
              fileRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/SpecialOffers/' + this.menuId + '/' + this.filesToArchive[i].resName)
            } else {
              fileRef = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/SpecialOffers/' + this.menuId + '/' + this.filesToArchive[i].resName)
            }
          } else {
            if (!this.getNotMigrated().includes(this.userId)) {
              fileRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/Menus/' + this.menuId + '/' + this.filesToArchive[i].resName)
            } else {
              fileRef = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/Menus/' + this.menuId + '/' + this.filesToArchive[i].resName)
            }
          }
          fileRef.getDownloadURL().then((url) => {
            this.globalLogger('HERE', url)
            // this.globalLogger(url)
            const xhr = new XMLHttpRequest()
            xhr.responseType = 'blob'
            xhr.onload = (event) => {
              const blob = xhr.response
              var file = new File([blob], fileRef.name, {type: blob.type})
              this.globalLogger('file1', file)
              let ref = null
              if (this.isSpecialOffer) {
                if (!this.getNotMigrated().includes(this.userId)) {
                  ref = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/SpecialOffersArchive/' + fileRef.name)
                } else {
                  ref = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/SpecialOffersArchive/' + fileRef.name)
                }
              } else {
                if (!this.getNotMigrated().includes(this.userId)) {
                  ref = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/MenusArchive/' + fileRef.name)
                } else {
                  ref = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/MenusArchive/' + fileRef.name)
                }
              }
              ref.put(file).then((snapshot) => {
                this.globalLogger('snapshot', snapshot)
                ref.getDownloadURL().then((url) => {
                  this.globalLogger('file2', file)
                  var zn = 1
                  for (let j = 0; j < this.archiveItems.length; j++) {
                    if (this.archiveItems[j].resName === file.name && this.archiveItems[j].resSize === file.size) {
                      this.globalLogger('zn e 0')
                      zn = 0
                    } else if (this.archiveItems[j].resName === file.name) {
                      this.globalLogger('samo imeto')
                      this.archiveItems = this.archiveItems.filter(x => x.resName !== file.name)
                    }
                  }
                  if (zn === 1) {
                    count2++
                    this.globalLogger(count2, 'count2')
                    this.globalLogger('zn e 1')
                    this.archiveItems.push({ 'resName': file.name, 'resSize': file.size })
                  }
                  this.globalLogger('File ' + file.name + ' successfully uploaded at ' + url)
                }).finally(() => {
                  this.globalLogger('finally new', this.archiveItems)
                  if (this.deleteFromBinItems.length > 0) {
                    for (let i = 0; i < this.deleteFromBinItems.length; i++) {
                      this.archiveItems = this.archiveItems.filter(c => c.resName !== this.deleteFromBinItems[i])
                    }
                    this.globalLogger('ARCHIVE ITEMS FILTERED: ', this.archiveItems)
                  }
                  if (this.isSpecialOffer) {
                    if (!this.getNotMigrated().includes(this.userId)) {
                      this.$store.state.database.ref('/neoslide/archive/' + this.workspaceId + '/specialOffers/').update({
                        items: this.archiveItems
                      })
                    } else {
                      this.$store.state.database.ref('/archive/' + this.userId + '/specialOffers/').update({
                        items: this.archiveItems
                      })
                    }
                  } else {
                    if (!this.getNotMigrated().includes(this.userId)) {
                      this.$store.state.database.ref('/neoslide/archive/' + this.workspaceId + '/menus/').update({
                        items: this.archiveItems
                      })
                    } else {
                      this.$store.state.database.ref('/archive/' + this.userId + '/menus/').update({
                        items: this.archiveItems
                      })
                    }
                  }
                  if (flag === 0) {
                    this.globalLogger('FLAG = 0')

                    let deletePromiseList = []

                    let removeMenuFilesRef = null
                    if (this.isSpecialOffer) {
                      if (!this.getNotMigrated().includes(this.userId)) {
                        removeMenuFilesRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/SpecialOffers/' + this.menuId)
                      } else {
                        removeMenuFilesRef = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/SpecialOffers/' + this.menuId)
                      }
                    } else {
                      if (!this.getNotMigrated().includes(this.userId)) {
                        removeMenuFilesRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/Menus/' + this.menuId)
                      } else {
                        removeMenuFilesRef = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/Menus/' + this.menuId)
                      }
                    }
                    removeMenuFilesRef.listAll().then(dir => {
                      dir.items.forEach(fileRef => {
                        if (this.filesToRemove.includes(fileRef.name)) {
                          this.globalLogger('removing file ', fileRef.name)
                          deletePromiseList.push(fileRef.delete())
                        }
                      })
                    })
                    Promise.all(deletePromiseList).then(() => {
                      this.submitFiles(isAdd)
                    })
                  }
                  flag = 1
                }).finally(() => {
                  this.globalLogger('second finally')
                  this.globalLogger('count:', count1, count2)
                  if (count1 === count2) {
                    this.finishedArchive = true
                    // proverka
                    let brojac = 0
                    let fileList1 = []
                    for (let itemId in this.items) {
                      if (this.items[itemId].file) {
                        fileList1.push(this.items[itemId].file)
                      }
                    }
                    let uniqueFiles1 = []
                    for (let file of fileList1) {
                      let isPresent1 = false
                      for (let otherFile of uniqueFiles1) {
                        if (file.name === otherFile.name) {
                          isPresent1 = true
                          break
                        }
                      }
                      if (!isPresent1) {
                        uniqueFiles1.push(file)
                        brojac++
                      }
                    }
                    // brojac e 0 -> nema za upload
                    if (brojac === 0) {
                      this.globalLogger('brojac e 0')
                      this.closeModal()
                      this.loadingComponent.close()
                    } else if (this.finishedUpload) {
                      this.globalLogger('finished upload e true vo archive')
                      this.closeModal()
                      this.loadingComponent.close()
                    }
                    // proverka
                  }
                })
              }).catch(error => {
                this.globalLogger('Submit files error: ', error)
              })
            }
            xhr.open('GET', url)
            this.globalLogger('url', url)
            xhr.send()
          }).catch((error) => {
            this.globalLogger('error', error)
          }).finally(() => {
            this.globalLogger('finally old')
          })
        }
      } else {
        let deletePromiseList = []
        let removeMenuFilesRef = null
        if (this.isSpecialOffer) {
          if (!this.getNotMigrated().includes(this.userId)) {
            removeMenuFilesRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/SpecialOffers/' + this.menuId)
          } else {
            removeMenuFilesRef = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/SpecialOffers/' + this.menuId)
          }
        } else {
          if (!this.getNotMigrated().includes(this.userId)) {
            removeMenuFilesRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/Menus/' + this.menuId)
          } else {
            removeMenuFilesRef = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/Menus/' + this.menuId)
          }
        }
        removeMenuFilesRef.listAll().then(dir => {
          dir.items.forEach(fileRef => {
            if (this.filesToRemove.includes(fileRef.name)) {
              deletePromiseList.push(fileRef.delete())
              /* fileRef.delete().then(() => {
                this.globalLogger('Deleted file ' + fileRef.name)
              }) */
            }
          })
        })
        Promise.all(deletePromiseList).then(() => {
          this.submitFiles(isAdd)
        })
      }
    },
    submitFiles (isAdd) {
      let fileList = []
      for (let itemId in this.items) {
        if (this.items[itemId].file) {
          fileList.push(this.items[itemId].file)
        }
      }

      if (fileList.length === 0) {
        this.globalLogger('Nothing to upload')
        let editMenuRef = null
        if (this.isSpecialOffer) {
          if (!this.getNotMigrated().includes(this.userId)) {
            editMenuRef = this.$store.state.database.ref('/neoslide/specialOfferMenu/' + this.workspaceId + '/' + this.menuId)
          } else {
            editMenuRef = this.$store.state.database.ref('/specialOfferMenu/' + this.userId + '/' + this.menuId)
          }
        } else {
          if (!this.getNotMigrated().includes(this.userId)) {
            editMenuRef = this.$store.state.database.ref('/neoslide/menu/' + this.workspaceId + '/' + this.menuId)
          } else {
            editMenuRef = this.$store.state.database.ref('/menu/' + this.userId + '/' + this.menuId)
          }
        }
        editMenuRef.update({
          items: this.items
        })
        var logItem = null
        if (isAdd) {
          for (let item in this.items) {
            logItem = Object.assign({}, this.items[item])
            logItem.ip_addr = this.jsonResp ? this.jsonResp.ip : ''
            logItem.city = this.jsonResp ? this.jsonResp.city : ''
            if (this.isSpecialOffer) {
              this.$analytics.logEvent('add_offer_item', logItem)
            } else {
              this.$analytics.logEvent('add_menu_item', logItem)
            }
          }
        } else {
          if (this.editedItemsLogs.length > 0) {
            for (let editLog in this.editedItemsLogs) {
              this.globalLogger('edit log: ', this.editedItemsLogs[editLog])
              if (this.isSpecialOffer) {
                this.$analytics.logEvent('edit_offer_item', this.editedItemsLogs[editLog])
              } else {
                this.$analytics.logEvent('edit_menu_item', this.editedItemsLogs[editLog])
              }
            }
          }
          if (this.addedItemsEditLogs.length > 0) {
            for (let addLog in this.addedItemsEditLogs) {
              this.globalLogger('add log: ', this.addedItemsEditLogs[addLog])
              if (this.isSpecialOffer) {
                this.$analytics.logEvent('add_offer_item_edit_off', this.addedItemsEditLogs[addLog])
              } else {
                this.$analytics.logEvent('add_menu_item_edit_men', this.addedItemsEditLogs[addLog])
              }
            }
          }
          for (let deleteLog in this.deletedItemsLogs) {
            this.globalLogger('NEMA ZA UPLOAD')
            this.globalLogger('delete log: ', this.deletedItemsLogs[deleteLog])
            if (this.isSpecialOffer) {
              this.$analytics.logEvent('delete_offer_item', this.deletedItemsLogs[deleteLog])
            } else {
              this.$analytics.logEvent('delete_menu_item', this.deletedItemsLogs[deleteLog])
            }
          }
        }
        if (this.filesToArchive.length === 0) {
          this.closeModal()
          this.loadingComponent.close()
          this.globalLogger('vtoro')
        }
      }

      let uniqueFiles = []

      for (let file of fileList) {
        let isPresent = false
        for (let otherFile of uniqueFiles) {
          if (file.name === otherFile.name) {
            isPresent = true
            break
          }
        }
        if (!isPresent) {
          uniqueFiles.push(file)
        }
      }
      let counter = 0
      for (let f of uniqueFiles) {
        let ref = null
        if (this.isSpecialOffer) {
          if (!this.getNotMigrated().includes(this.userId)) {
            ref = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/SpecialOffers/' + this.menuId + '/' + f.name)
          } else {
            ref = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/SpecialOffers/' + this.menuId + '/' + f.name)
          }
        } else {
          if (!this.getNotMigrated().includes(this.userId)) {
            ref = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/Menus/' + this.menuId + '/' + f.name)
          } else {
            ref = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/Menus/' + this.menuId + '/' + f.name)
          }
        }
        ref.put(f).then((snapshot) => {
          ref.getDownloadURL().then((url) => {
            this.globalLogger('File ' + f.name + ' successfully uploaded at ' + url)
            for (let id in this.items) {
              if ((this.items[id].file && this.items[id].file.name === f.name) || this.items[id].resourceName === f.name) {
                this.items[id].resourceName = f.name
                this.items[id].imageUrl = url
                var logItem = Object.assign({}, this.items[id])
                logItem.ip_addr = this.jsonResp ? this.jsonResp.ip : ''
                logItem.city = this.jsonResp ? this.jsonResp.city : ''
                if (isAdd) {
                  this.addedItemsLogs.push(logItem)
                  // this.$analytics.logEvent('add_item', logItem)
                } else {
                  this.addedItemsEditLogs.push(logItem)
                }
                // this.globalLogger('FILE SIZE: ', this.items[id].file.size)
              }
            }
            counter++
          }).finally(() => {
            this.globalLogger('FINALLY ok')
            if (this.isSpecialOffer) {
              if (!this.getNotMigrated().includes(this.userId)) {
                this.$store.state.database.ref('/neoslide/specialOfferMenu/' + this.workspaceId + '/' + this.menuId).update({
                  items: this.items
                })
              } else {
                this.$store.state.database.ref('/specialOfferMenu/' + this.userId + '/' + this.menuId).update({
                  items: this.items
                })
              }
            } else {
              if (!this.getNotMigrated().includes(this.userId)) {
                this.$store.state.database.ref('/neoslide/menu/' + this.workspaceId + '/' + this.menuId).update({
                  items: this.items
                })
              } else {
                this.$store.state.database.ref('/menu/' + this.userId + '/' + this.menuId).update({
                  items: this.items
                })
              }
            }
            if (counter === uniqueFiles.length) {
              this.globalLogger('treto')
              this.finishedUpload = true
              if (this.filesToArchive.length === 0) {
                this.loadingComponent.close()
                this.closeModal()
              } else if (this.finishedArchive) {
                this.globalLogger('finished archive e true vo upload')
                this.loadingComponent.close()
                this.closeModal()
              }
              if (isAdd) {
                for (let addLog in this.addedItemsLogs) {
                  this.globalLogger('add log: ', this.addedItemsLogs[addLog])
                  if (this.isSpecialOffer) {
                    this.$analytics.logEvent('add_offer_item', this.addedItemsLogs[addLog])
                  } else {
                    this.$analytics.logEvent('add_menu_item', this.addedItemsLogs[addLog])
                  }
                }
              } else {
                if (this.editedItemsLogs.length > 0) {
                  for (let editLog in this.editedItemsLogs) {
                    this.globalLogger('edit log: ', this.editedItemsLogs[editLog])
                    if (this.isSpecialOffer) {
                      this.$analytics.logEvent('edit_offer_item', this.editedItemsLogs[editLog])
                    } else {
                      this.$analytics.logEvent('edit_menu_item', this.editedItemsLogs[editLog])
                    }
                  }
                }
                if (this.addedItemsEditLogs.length > 0) {
                  for (let addLog in this.addedItemsEditLogs) {
                    this.globalLogger('add log: ', this.addedItemsEditLogs[addLog])
                    if (this.isSpecialOffer) {
                      this.$analytics.logEvent('add_offer_item_edit_off', this.addedItemsEditLogs[addLog])
                    } else {
                      this.$analytics.logEvent('add_menu_item_edit_men', this.addedItemsEditLogs[addLog])
                    }
                  }
                }
                for (let deleteLog in this.deletedItemsLogs) {
                  this.globalLogger('IMA ZA UPLOAD')
                  this.globalLogger('delete log: ', this.deletedItemsLogs[deleteLog])
                  if (this.isSpecialOffer) {
                    this.$analytics.logEvent('delete_offer_item', this.deletedItemsLogs[deleteLog])
                  } else {
                    this.$analytics.logEvent('delete_menu_item', this.deletedItemsLogs[deleteLog])
                  }
                }
              }
            }
          })
        }).catch(error => {
          this.globalLogger('Submit files error: ', error)
          let itemName = null
          let added = false
          for (let id in this.items) {
            if ((this.items[id].file && this.items[id].file.name === f.name) || this.items[id].resourceName === f.name) {
              itemName = this.items[id].name
              if (this.items[id].imageUrl === undefined) {
                added = true
                this.items = this.items.filter((x) => { return this.items.indexOf(x) !== parseInt(id) })
                break
              }
            }
          }
          counter++
          this.loadingComponent.close()
          this.closeModal()
          let mess = null
          if (added) {
            mess = 'Item "' + itemName + '" is not added because file ' + f.name + ' is <b>too big</b>.'
          } else {
            mess = 'Item "' + itemName + '" is not updated because file ' + f.name + ' is <b>too big</b>.'
          }
          this.$buefy.dialog.alert({
            title: 'Upload failed',
            message: mess,
            type: 'is-danger',
            hasIcon: true,
            icon: 'times-circle',
            iconPack: 'fa',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }).finally(() => {
          this.globalLogger('FINALLY error')
          if (this.isSpecialOffer) {
            if (!this.getNotMigrated().includes(this.userId)) {
              this.$store.state.database.ref('/neoslide/specialOfferMenu/' + this.workspaceId + '/' + this.menuId).update({
                items: this.items
              })
            } else {
              this.$store.state.database.ref('/specialOfferMenu/' + this.userId + '/' + this.menuId).update({
                items: this.items
              })
            }
          } else {
            if (!this.getNotMigrated().includes(this.userId)) {
              this.$store.state.database.ref('/neoslide/menu/' + this.workspaceId + '/' + this.menuId).update({
                items: this.items
              })
            } else {
              this.$store.state.database.ref('/menu/' + this.userId + '/' + this.menuId).update({
                items: this.items
              })
            }
          }
        })
      }
    },
    cancelEdit () {
      if (this.editEnabled) {
        this.name = this.editStaticMenuRef.name
        this.items = [...this.editStaticMenuRef.items]
      }
      this.closeModal()
    },
    dragstart (payload) {
      this.draggingRow = payload.row
      this.draggingRowIndex = payload.index
      payload.event.dataTransfer.effectAllowed = 'copy'
    },
    dragover (payload) {
      payload.event.dataTransfer.dropEffect = 'copy'
      payload.event.target.closest('tr').classList.add('is-selected')
      payload.event.preventDefault()
    },
    dragleave (payload) {
      payload.event.target.closest('tr').classList.remove('is-selected')
      payload.event.preventDefault()
    },
    drop (payload) {
      payload.event.target.closest('tr').classList.remove('is-selected')
      let droppedOnRowIndex = payload.index
      let temp = this.items[this.draggingRowIndex]
      this.items[this.draggingRowIndex] = this.items[droppedOnRowIndex]
      this.items[droppedOnRowIndex] = temp
      this.refreshItemsTable()
    },
    closeModal () {
      if (this.propParentFn) {
        this.propParentFn()
      }
      this.$parent.close()
    },
    storageAvailable () {
      this.globalLogger('Storage available')
      this.totalStorageSize = 0
      for (let menu in this.menus) {
        var sum = 0
        var menuRef = Object.assign({}, this.$store.getters.getMenu(menu))
        if (menuRef.items !== undefined) {
          var menuItems = [...menuRef.items.filter(x => x.resourceName !== '')]
          menuItems = menuItems.filter((v, i, a) => a.findIndex(v2 => (v2.resourceName === v.resourceName)) === i)
          var noResources = menuItems.length
          // this.numbersRes[playlist] = noResources
          if (noResources > 0) {
            for (let i = 0; i < menuItems.length; i++) {
              if (menuItems[i].resourceName !== '') {
                sum += menuItems[i].resourceSize
              }
            }
            this.totalStorageSize += sum
          }
          // this.totalPlaylistsSize
        }
      }
      // archive begin
      if (this.menusArchive !== null) {
        for (let i = 0; i < this.menusArchive.items.length; i++) {
          this.totalStorageSize += this.menusArchive.items[i].resSize
        }
      }
      if (this.playlistsArchive !== null) {
        for (let x = 0; x < this.playlistsArchive.items.length; x++) {
          this.totalStorageSize += this.playlistsArchive.items[x].resSize
        }
      }
      if (this.specialOffersArchive !== null) {
        for (let y = 0; y < this.specialOffersArchive.items.length; y++) {
          this.totalStorageSize += this.specialOffersArchive.items[y].resSize
        }
      }
      // archive end
      for (let playlist in this.playlists) {
        var sum1 = 0
        var playlistRef = Object.assign({}, this.$store.getters.getPlaylist(playlist))
        if (playlistRef.items !== undefined) {
          var playlistItems = [...playlistRef.items.filter(x => x.resourceName !== '')]
          playlistItems = playlistItems.filter((v, i, a) => a.findIndex(v2 => (v2.resourceName === v.resourceName)) === i)
          var noResources1 = playlistItems.length
          if (noResources1 > 0) {
            for (let i = 0; i < playlistItems.length; i++) {
              if (playlistItems[i].resourceName !== '') {
                sum1 += playlistItems[i].resourceSize
              }
            }
            this.totalStorageSize += sum1
          }
        }
      }
      for (let offer in this.specialOffers) {
        var sum2 = 0
        var offerRef = Object.assign({}, this.$store.getters.getSpecialOffer(offer))
        if (offerRef.items !== undefined) {
          var offerItems = [...offerRef.items.filter(x => x.resourceName !== '')]
          offerItems = offerItems.filter((v, i, a) => a.findIndex(v2 => (v2.resourceName === v.resourceName)) === i)
          var noResources2 = offerItems.length
          if (noResources2 > 0) {
            for (let i = 0; i < offerItems.length; i++) {
              if (offerItems[i].resourceName !== '') {
                sum2 += offerItems[i].resourceSize
              }
            }
            this.totalStorageSize += sum2
          }
        }
      }
      this.globalLogger('before: ', this.totalStorageSize)
      this.totalStorageSize -= this.sizesMinus
      this.globalLogger('after minus: ', this.totalStorageSize)
      this.totalStorageSize += this.sizesPlus
      this.globalLogger('after: ', this.totalStorageSize)
      this.globalLogger('ITEMI: ', this.items)
      return (this.totalStorageSize < 1073741824)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/menu/MenuAddEdit.vue